/**
 * Texts for Factsheets page
 *
 * PDF DOWNLOAD INSTRUCTIONS:
 * Each factsheet has an image and a PDF download URL.
 * On image click, the PDF will be downloaded.
 * Simply edit the 'pdfUrl' field in each factsheet object below.
 */
export const factsheetsPageText = {
  title: "Factsheets - CamAPS FX",
  titleMeta: "CamAPS FX Factsheets - Quick reference guides",
  descriptionMeta:
    "Download helpful factsheets and guides for quick reference about CamAPS FX.",
  keywords:
    "camaps fx factsheets, camaps guides, diabetes app guides, insulin pump factsheets, cgm guides, pdf downloads",
  localeMeta: "fr_fr",

  mainHeader: "Fiches d'information",
  mainSubHeader: "Téléchargez des fiches d'information et des guides utiles.",

    altHelp: 'Aide',
    altInfo: 'Info',
    altAppStore: 'Télécharger sur l\'App Store',
    altGooglePlay: 'Disponible sur Google Play',
    ariaGoToSlide: 'Aller à la diapositive {n}',
    ariaNextSlide: 'Diapositive suivante',
    ariaPrevSlide: 'Diapositive précédente',
    videoNotSupportedText: 'Votre navigateur ne prend pas en charge la balise vidéo.',
    virtualModeTooltipText: 'Le mode virtuel vous permet d\'essayer l\'application sans être connecté à une vraie pompe à insuline et à un capteur CGM.',
    closeButtonText: 'Fermer',
    filterAll: 'Tous',
    filterYpsoPump: 'YpsoPump',
    filterDana: 'Dana',
    sortNewest: 'Les plus récents',
    sortOldest: 'Les plus anciens',
    sortAZ: 'A-Z',
    sortPopular: 'Les plus populaires',
  // Getting Started Section
  gettingStartedHeader: "Prêt à commencer?",
  step1Title: "<strong>Étape 1:</strong> Téléchargez l'application",
  step2Title: "<strong>Étape 2:</strong> Créez un compte",
  step3Title: "<strong>Étape 3:</strong> Commencez la formation essentielle dans l'application",
  step4Title: "<strong>&#201;tape 4:</strong> Associez la pompe et le CGM de votre choix (avec l'approbation de votre &eacute;quipe soignante) ou explorez l'application avec le <strong>Mode Virtuel</strong>",

  // Support Section
  supportSectionTitle: "Besoin d'aide supplémentaire?",
  supportSectionText:
    "Notre équipe d'assistance est là pour répondre à vos questions.",
  supportButtonText: "CONTACTER LE SUPPORT",

  factsheets: [
    // {
    //     id: 1,
    //     title: 'Linking CamAPS FX to Glooko',
    //     description: 'Linking CamAPS FX to Glooko',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-001.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-001-linking-glooko.pdf'
    // },
    // {
    //     id: 2,
    //     title: 'Generating a PDF report',
    //     description: 'Generating a PDF report',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-002.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-002-pdf-report.pdf'
    // },
    // {
    //     id: 3,
    //     title: 'Managing Hypos on CamAPS FX',
    //     description: 'Managing Hypos on CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-003.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-003-managing-hypos.pdf'
    // },
    // {
    //     id: 4,
    //     title: 'Managing Illness on CamAPS FX',
    //     description: 'Managing Illness on CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-004.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-004-managing-illness.pdf'
    // },
    // {
    //     id: 5,
    //     title: 'Managing Meals on CamAPS FX',
    //     description: 'Managing Meals on CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-005.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-005-managing-meals.pdf'
    // },
    // {
    //     id: 6,
    //     title: 'Travelling with CamAPS FX',
    //     description: 'Travelling with CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-006.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-006-travelling.pdf'
    // },
    // {
    //     id: 7,
    //     title: 'Getting support on CamAPS FX',
    //     description: 'Getting support on CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-007.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-007-getting-support.pdf'
    // },
    // {
    //     id: 8,
    //     title: 'Using CamAPS FX at school, nursery or in childcare',
    //     description: 'Using CamAPS FX at school, nursery or in childcare',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-008.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-008-at-school.pdf'
    // },
    // {
    //     id: 9,
    //     title: 'CamAPS FX School\'s Care Plan Template',
    //     description: 'CamAPS FX School\'s Care Plan Template',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-009.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-009-care-plan-template.docx'
    // },
    // {
    //     id: 10,
    //     title: 'Using CamAPS FX in virtual (demo) mode',
    //     description: 'Using CamAPS FX in virtual (demo) mode',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-010.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-010-demo-mode.pdf'
    // },
    // {
    //     id: 11,
    //     title: 'CamAPS FX and its Patency Pulse',
    //     description: 'CamAPS FX and its Patency Pulse',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-011.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-011-patency-pulse.pdf'
    // },
    // {
    //     id: 12,
    //     title: 'Having Surgery or a Procedure when using CamAPS FX',
    //     description: 'Having Surgery or a Procedure when using CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-012.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-012-surgery-procedure.pdf'
    // },
    // {
    //     id: 13,
    //     title: 'Managing Pregnancy on CamAPS FX',
    //     description: 'Managing Pregnancy on CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-013.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-013-managing-pregnancy.pdf'
    // },
    // {
    //     id: 14,
    //     title: 'Optimising CamAPS FX',
    //     description: 'Optimising CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-014.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-014-optimising.pdf'
    // },
    // {
    //     id: 15,
    //     title: 'Starting CamAPS FX - training slide deck',
    //     description: 'Starting CamAPS FX - training slide deck',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-015.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-015-training-slides.pdf'
    // },
    // {
    //     id: 16,
    //     title: 'Preparing to start CamAPS FX',
    //     description: 'Preparing to start CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-016.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-016-preparing-to-start.pdf'
    // },
    // {
    //     id: 17,
    //     title: 'Introduction to mylife CamAPS FX',
    //     description: 'Introduction to mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-017.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-017-introduction-fr-fr.pdf'
    // },
    // {
    //     id: 18,
    //     title: 'mylife CamAPS FX Specifications',
    //     description: 'mylife CamAPS FX Specifications',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-018.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-018-specifications-fr-fr.pdf'
    // },
    // {
    //     id: 19,
    //     title: 'mylife CamAPS FX Infographic',
    //     description: 'mylife CamAPS FX Infographic',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-019.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-019-infographic-fr-fr.pdf'
    // },
    // {
    //     id: 20,
    //     title: 'Choice of Sensors',
    //     description: 'Choice of Sensors',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-020.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-020-sensors-fr-fr.pdf'
    // },
    // {
    //     id: 21,
    //     title: 'Starting mylife CamAPS FX',
    //     description: 'Starting mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-021.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-021-starting-fr-fr.pdf'
    // },
    // {
    //     id: 22,
    //     title: 'Patency pulse on mylife CamAPS FX',
    //     description: 'Patency pulse on mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-022.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-022-patency-pulse-fr-fr.pdf'
    // },
    // {
    //     id: 23,
    //     title: 'Travelling with mylife CamAPS FX',
    //     description: 'Travelling with mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-023.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-023-travelling-fr-fr.pdf'
    // },
    // {
    //     id: 24,
    //     title: 'Managing illness on mylife CamAPS FX',
    //     description: 'Managing illness on mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-024.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-024-illness-fr-fr.pdf'
    // },
    // {
    //     id: 25,
    //     title: 'Managing mylife CamAPS FX during surgery, CT or MRI scans',
    //     description: 'Managing mylife CamAPS FX during surgery, CT or MRI scans',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-025.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-025-surgery-fr-fr.pdf'
    // },
    // {
    //     id: 26,
    //     title: 'Managing low glucose levels (hypos) with mylife CamAPS FX',
    //     description: 'Managing low glucose levels (hypos) with mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-026.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-026-hypos-fr-fr.pdf'
    // },
    // {
    //     id: 27,
    //     title: 'Optimising mylife CamAPS FX',
    //     description: 'Optimising mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-027.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-027-optimising-fr-fr.pdf'
    // },
    // {
    //     id: 28,
    //     title: 'Using mylife CamAPS FX at school, nursery or when childminding',
    //     description: 'Using mylife CamAPS FX at school, nursery or when childminding',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-028.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-028-school-fr-fr.pdf'
    // },
    // {
    //     id: 29,
    //     title: 'Generating a PDF report',
    //     description: 'Generating a PDF report',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-029.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-029-pdf-report.pdf'
    // },
    // {
    //     id: 30,
    //     title: 'Linking mylife CamAPS FX to Glooko',
    //     description: 'Linking mylife CamAPS FX to Glooko',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-030.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-030-linking-glooko.pdf'
    // }
    {
      id: 1,
      title: "Ajustement des tailles de repas prédéfinies",
      description: "Ajustement des tailles de repas prédéfinies",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/adjusting_meal_sizes.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/fr_FR/adjusting_meal_sizes_camdiab_FR.pdf",
      views: 4000,
    },
    {
      id: 2,
      title: "Calibrage d’un capteur",
      description: "Calibrage d’un capteur",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/calibrating_a_sensor.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/fr_FR/calibrating_a_sensor_camdiab_FR.pdf",
      views: 3000,
    },
    {
      id: 3,
      title: "Changement d’unités de glucides",
      description: "Changement d’unités de glucides",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/changing_carbohydrate_units.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/fr_FR/changing_carbohydrate_units_camdiab_FR.pdf",
      views: 2000,
    },
    {
      id: 4,
      title: "Saisie du poids corporel",
      description: "Saisie du poids corporel",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/entering_body_weight.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/fr_FR/entering_body_weight_camdiab_FR.pdf",
      views: 31000,
    },
    {
      id: 5,
      title: "Saisie de la dose totale quotidienne (DTQ)",
      description: "Saisie de la dose totale quotidienne (DTQ)",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/entering_total_daily_dose.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/fr_FR/entering_total_daily_dose_camdiab_FR.pdf",
      views: 30000,
    },
    {
      id: 6,
      title: "Correction manuelle",
      description: "Correction manuelle",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/giving_a_correction.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/fr_FR/giving_a_correction_camdiab_FR.pdf",
      views: 22000,
    },
    {
      id: 7,
      title: "Administration d’un bolus repas",
      description: "Administration d’un bolus repas",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/giving_a_meal_bolus.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/fr_FR/giving_a_meal_bolus_camdiab_FR.pdf",
      views: 26000,
    },
    {
      id: 8,
      title: "Comment CamAPS FX administre-t-il l’insuline ?",
      description: "Comment CamAPS FX administre-t-il l’insuline ?",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/how_does_camaps_fx_deliver_insulin.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/fr_FR/how_does_camaps_fx_deliver_insulin_camdiab_FR.pdf",
      views: 35000,
    },
    {
      id: 9,
      title: "Comment se fait l’apprentissage de CamAPS FX ?",
      description: "Comment se fait l’apprentissage de CamAPS FX ?",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/how_does_camaps_fx_learn.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/fr_FR/how_does_camaps_fx_learn_camdiab_FR.pdf",
      views: 36000,
    },
    {
      id: 10,
      title: "Gestion de la grossesse",
      description: "Gestion de la grossesse",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/managing_pregnancy.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/fr_FR/managing_pregnancy_camdiab_FR.pdf",
      views: 34000,
    },
    {
      id: 11,
      title: "Appairage de la pompe et du capteur",
      description: "Appairage de la pompe et du capteur",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/pairing_pump_and_sensor.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/fr_FR/pairing_pump_and_sensor_camdiab_FR.pdf",
      views: 32000,
    },
    {
      id: 12,
      title: "Impulsion de perméabilité",
      description: "Impulsion de perméabilité",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/patency_pulse.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/fr_FR/patency_pulse_camdiab_FR.pdf",
      views: 1000,
    },
    {
      id: 13,
      title: "Programmation du calculateur de bolus",
      description: "Programmation du calculateur de bolus",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/programming_bolus_calculator.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/fr_FR/programming_bolus_calculator_camdiab_FR.pdf",
      views: 29000,
    },
    {
      id: 14,
      title: "Alertes",
      description: "Alertes",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/setting_alerts.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/fr_FR/setting_alerts_camdiab_FR.pdf",
      views: 21000,
    },
    {
      id: 15,
      title: "Cible personnalisée de glucose (CPG)",
      description: "Cible personnalisée de glucose (CPG)",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/setting_personal_glucose_target.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/fr_FR/setting_personal_glucose_target_camdiab_FR.pdf",
      views: 28000,
    },
    {
      id: 16,
      title: "Partage des données",
      description: "Partage des données",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/sharing_diabetes_data.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/fr_FR/sharing_diabetes_data_camdiab_FR.pdf",
      views: 20000,
    },
    {
      id: 17,
      title: "Principalesastucestechniques",
      description: "Principalesastucestechniques",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/top_technical_tips.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/fr_FR/top_technical_tips_camdiab_FR.pdf",
      views: 33000,
    },
    {
      id: 18,
      title: "Utilisation de la fonction “Ajouter un repas”",
      description: "Utilisation de la fonction “Ajouter un repas”",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/using_add_meal.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/fr_FR/using_add_meal_camdiab_FR.pdf",
      views: 25000,
    },
    {
      id: 19,
      title: "Utilisation de la fonction “Auto mode”",
      description: "Utilisation de la fonction “Auto mode”",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/using_auto_mode.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/fr_FR/using_auto_mode_camdiab_FR.pdf",
      views: 27000,
    },
    {
      id: 20,
      title: "Utilisation de la fonction “Blocage”",
      description: "Utilisation de la fonction “Blocage”",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/using_block.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/fr_FR/using_block_camdiab_FR.pdf",
      views: 19000,
    },
    {
      id: 21,
      title: "Utilisation de la fonction “Boost”",
      description: "Utilisation de la fonction “Boost”",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/using_boost.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/fr_FR/using_boost_camdiab_FR.pdf",
      views: 23000,
    },
    {
      id: 22,
      title: "Utilisation de la fonction “Ease-off”",
      description: "Utilisation de la fonction “Ease-off”",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/using_ease_off.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/fr_FR/using_ease_off_camdiab_FR.pdf",
      views: 24000,
    },
  ],
};
